export const i18nViews = {
	unuathenticatedLabel: {
		bg: 'Влезте в профила си за да достъпите тази страница.',
		en: 'You need to login to view this page.'
	},
	unauthorizedLabel: {
		bg: 'Нямате нужните права за да достъпите тази страница.',
		en: 'You do not have the required permission to view this page.'
	}
}